const ValidationUtils = {
	getFieldWrapper: (fieldType) => {
		switch (fieldType) {
			case 'radio':
				return '.lta-form-check-group';

			case 'checkbox':
				return '.lta-form-checkbox';

			case 'date':
				return '.lta-text-dob';

			case 'select':
				return '.lta-select';

			default:
				return '.lta-text-input__wrapper';
		}
	},
	getErrorClasses: (fieldType) => {
		switch (fieldType) {
			case 'radio':
			case 'password':
			case 'checkbox':
			case 'date':
			case 'select':
				return ['is-invalid', 'is-focused'];

			default:
				return ['is-invalid', 'is-focused', 'has-icon'];
		}
	}
};

export default ValidationUtils;
